import { render, staticRenderFns } from "./UserStats.vue?vue&type=template&id=a9fa8e82"
import script from "./UserStats.vue?vue&type=script&lang=js"
export * from "./UserStats.vue?vue&type=script&lang=js"
import style0 from "./UserStats.vue?vue&type=style&index=0&id=a9fa8e82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports